var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-wrapper"},[_c('div',{staticClass:"main-menu has-shadow has-padding-bottom has-padding-top has-background-grey-light"},[_c('Menu',{staticClass:"has-padding-bottom"}),_c('MenuFooter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }